/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { baseActions } from "document-model";
import { vetraPackageBaseOperationsActions } from "./gen/creators.js";

/** Actions for the VetraPackage document model */

export const actions = { ...baseActions, ...vetraPackageBaseOperationsActions };
